import { forwardRef, type Ref, type SVGProps } from "react";

function SvgEllipsis(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="3.5" cy="9.5" r="1.5" fill="currentColor" />
      <circle cx="10" cy="9.5" r="1.5" fill="currentColor" />
      <circle cx="16.5" cy="9.5" r="1.5" fill="currentColor" />
    </svg>
  );
}

const ForwardRef = forwardRef(SvgEllipsis);
export default ForwardRef;
